import React, { useEffect, useMemo, useRef } from 'react';
import './style.scss';
import useFreeNft, {
  IUseFreeNft
} from '../../../../../../hooks/freeNft/useFreeNft';
import LandingMintSectionNftImage from './image';
import LandingMintSectionNftDesc from './description';
import LandingMintSectionMintButton from './mintButton';
import LandingMintSectionArrows from './arrows';
import useWindowSize from '../../../../../../hooks/useWindowSize';
import MarketPagePromoCode from '../../../../marketPage/promoCode';
import { MarketNftStatuses } from '../../../../marketPage/Interfaces';
import usePromo from '../../../../marketPage/promoCode/Context';
import clsx from 'clsx';

const LandingMintSectionNft = () => {
  const nft = useFreeNft();
  const { reset } = usePromo();
  const prevNftId = useRef<string | null>(null);

  const [sizeX] = useWindowSize();

  const isMobile = useMemo(() => {
    return sizeX <= 1200;
  }, [sizeX <= 1200]);

  useEffect(() => {
    if (nft.nft?._id !== prevNftId.current) {
      reset();
    }
  }, [nft.nft]);

  if (isMobile) {
    return <Mobile freeNft={nft} />;
  }

  return <PC freeNft={nft} />;
};

interface Props {
  freeNft: IUseFreeNft;
}

const PC = ({ freeNft }: Props) => {
  const {
    loading,
    nftLoading,
    nft,
    noAvailable,
    handleRightClick,
    handleLeftClick,
    error
  } = freeNft;

  const noNft = noAvailable || error.status || loading;

  return (
    <div className='lmis-nft'>
      <LandingMintSectionNftImage
        nft={nft}
        loading={nftLoading}
        showPh={noNft}
        className='lmis-nft-image-wrapper'
      />
      <div className='lmis-nft-content'>
        <div className='lmis-nft-content-ph' />
        <div className='lmis-nft-content-body'>
          <LandingMintSectionNftDesc
            nft={nft}
            loading={nftLoading}
            error={error.status}
            noAvail={noAvailable}
          />
          {!noNft && (
            <>
              <LandingMintSectionMintButton
                className='lmis-nft-content-button'
                token={nft?.token}
              />
              <LandingMintSectionArrows
                handleLeft={handleLeftClick}
                handleRight={handleRightClick}
                loading={nftLoading}
                className='lmis-nft-content-arrows'
              />
              <MarketPagePromoCode status={MarketNftStatuses.AVAILABLE} />
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const Mobile = ({ freeNft }: Props) => {
  const {
    loading,
    nftLoading,
    nft,
    noAvailable,
    handleRightClick,
    handleLeftClick,
    error
  } = freeNft;

  const noNft = noAvailable || error.status || loading;

  return (
    <div className='lmis-nft'>
      <div className='lmis-nft-top'>
        <LandingMintSectionNftImage
          nft={nft}
          loading={nftLoading}
          showPh={noNft}
          className='lmis-nft-image-wrapper'
        />
        {!noNft && (
          <LandingMintSectionArrows
            handleLeft={handleLeftClick}
            handleRight={handleRightClick}
            loading={nftLoading}
          />
        )}
      </div>
      <div className={clsx('lmis-nft-bottom', noNft && 'lmis-nft-bottom-ph')}>
        <LandingMintSectionNftDesc
          nft={nft}
          loading={nftLoading}
          error={error.status}
          noAvail={noAvailable}
        />
        {!noNft && (
          <>
            <LandingMintSectionMintButton
              className='lmis-nft-content-button'
              token={nft?.token}
            />
            <MarketPagePromoCode
              status={MarketNftStatuses.AVAILABLE}
              className='lmis-nft-content-promo'
            />
          </>
        )}
      </div>
    </div>
  );
};

export default LandingMintSectionNft;
